import FactureDetailController from './facture.detail.controller';

export default {
	bindings: { id: '=', modalInstance: '<' },
	template: require('./facture.detail.html'),
	controller: FactureDetailController
};
